import React, { useEffect, useState } from 'react';
import ErrorBoundary from '../../../ErrorBoundary';
import moment from 'moment';
import { InputGroup, InputGroupText } from 'reactstrap';
import { Field, Formik } from 'formik';
import { dateFormate } from 'utils/columns';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import { useLocation } from 'react-router-dom';
let hasDatePopupOpen = false;
const InputDateCellRender = ({
    rowData,
    columnName,
    updateRowValue,
    required = false,
    hasTouched = false,endDateFormatter,terminationDateProp,
    crosswalktab,
    showWarning,
    effectiveTempDate,
    setEffectiveTempDate
}) => {
  
    const subProps = {};
    const value = rowData[columnName] || '';
    const [text, setText] = useState(null);
   
  const location = useLocation();

    useEffect(() => {
        if(value !== '')
        {
            var newDate = dateFormate(new Date(value));
            setText(newDate);
        }
        if(location.pathname == '/payor'){
            setEffectiveTempDate(null);
        }
    }, []);

    const handlerChange = (startDate) => {
      
      if(startDate == null && columnName == "endDate"){
          setText(null);
          updateRowValue(null, columnName, rowData);
      }
      else{
        let stDate = dateFormate(new Date(startDate));
        setText(stDate);
        updateRowValue(stDate, columnName, rowData);
        if(columnName === 'effectiveDate' && location.pathname == '/payor'){
          setEffectiveTempDate(stDate);
        }
      }
      
    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
  const getOpenToDate = () => {
    if (
      terminationDateProp &&
      columnName === "terminationDate" && location.pathname !== '/payor'
    ) {
      const effectiveDateToUse =
        effectiveTempDate || rowData.effectiveDate;

      if (effectiveDateToUse) {
        const dt = new Date(effectiveDateToUse);
        dt.setDate(dt.getDate() + 1);
        return dateFormate(dt);
      }
    }
  if (location.pathname !== '/crosswalk') return null;

  const stDate = rowData.startDate ? new Date(rowData.startDate) : null;
  const ceDate = rowData.ceLiveDate ? new Date(rowData.ceLiveDate) : null;
  const minStartDate = rowData.minmumStartDate ? new Date(rowData.minmumStartDate) : null;

  if (crosswalktab === 'crosswalkQueue' && minStartDate) {
    return dateFormate(new Date(minStartDate.setDate(minStartDate.getDate() + 1)));
  }

  if ((crosswalktab === 'chargeCode' || crosswalktab === 'crosswalk') && stDate) {
    return dateFormate(stDate);
  }

  if (ceDate) {
    return dateFormate(new Date(ceDate.setDate(ceDate.getDate())));
  }

  return null;
};

// const getMaxDate = () => {
//   if (
//     terminationDateProp &&
//     columnName === 'effectiveDate' &&
//     rowData.terminationDate
//   ) {
//     const terminationDate = new Date(rowData.terminationDate);
//     return dateFormate(new Date(terminationDate.setDate(terminationDate.getDate() - 1)));
//   }
//   return false;
// };

  const getMinDate = () => {
    if (location.pathname === '/crosswalk') {
      const minStartDate = rowData.minmumStartDate ? new Date(rowData.minmumStartDate) : null;
      const ceDate = rowData.ceLiveDate ? new Date(rowData.ceLiveDate) : null;

      if (crosswalktab === 'crosswalkQueue' && minStartDate) {
        return dateFormate(new Date(minStartDate.setDate(minStartDate.getDate() + 1)));
      }

      if (ceDate) {
        return dateFormate(new Date(ceDate.setDate(ceDate.getDate())));
      }
    }

    const effectiveDate = rowData.effectiveDate ? new Date(rowData.effectiveDate) : null;
    const startDate = rowData.startDate ? new Date(rowData.startDate) : null;
    if (
      terminationDateProp &&
      columnName === "terminationDate"
    ) {
      const effectiveDateToUse =
        effectiveTempDate || rowData.effectiveDate;

      if (effectiveDateToUse) {
        const dt = new Date(effectiveDateToUse);
        dt.setDate(dt.getDate() + 1);
        return dateFormate(dt);
      }
    }

  if (endDateFormatter) {
    return dateFormate(new Date(new Date().setDate(new Date().getDate() + 1)));
  }

  return startDate ? dateFormate(startDate) : null;
};

return (
      <div>
        <ErrorBoundary>
          <Formik>
            <InputGroup onMouseLeave={handleMouseLeave}>
              <Field
                portalId="root portal"
                type="text"
                id={columnName}
                name={columnName}
                autoComplete="off"
                placeholder="Select a date"
                value={text}
                showWarning = {showWarning}
                component={FormikDatePicker}
                onChange={handlerChange}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                isClearable ={columnName == 'endDate' ? true : false}
                openToDate={getOpenToDate()}
               minDate={getMinDate()}
                //maxDate={getMaxDate()}  
              />
              <InputGroupText onClick={() => handleDateClick(columnName)}>
                <img src={Calendar} alt="" />
              </InputGroupText>
            </InputGroup>
          </Formik>
           {(showWarning !== '' && (columnName === 'endDate' || columnName === 'terminationDate')) ? (
        <div className="text-danger">
          {showWarning}
        </div>
      ) : (showWarning !== '' && columnName === 'startDate' && crosswalktab === 'crosswalkQueue') ? (
        <div className="text-danger">
          {showWarning}
        </div>) : (showWarning !== '' && columnName === 'invoicedDate') ?
        <div className="text-danger">
          {showWarning}
        </div> : null }
        </ErrorBoundary>
      </div>
    );
};

export default InputDateCellRender;
